export default {
  zh: {
    inviteRecord: '邀请记录',
    rewardCash: '奖励记录',
    friends: '好友',
    rules: '平台奖励规则'
  },
  en: {
    inviteRecord: 'Invitation Records',
    rewardCash: 'Rewards',
    friends: 'Friends',
    rules: 'Reward Rules'
  }
}



// WEBPACK FOOTER //
// ./src/components/commission/inviteRecord/lang.js